import React, { useState, useRef, useEffect } from 'react';
import Heart from '../components/Icons/IconHeart';
import BuyBtnAnim from '../components/Anim/BuyButtonAnim';

const SAConfirmationPage = ({ animationDelay = 1000 }) => {
  const [buyClick, setBuyClick] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);
  const buyRef = useRef(null);

  const handleClick = () => {
    setStartAnimation(false);
    setBuyClick(false);
    setBuyClick(true);
  };

  useEffect(() => {
    let timer;
    if (buyClick) {
      timer = setTimeout(() => {
        setStartAnimation(true);
      }, animationDelay);
    }
    return () => clearTimeout(timer);
  }, [buyClick, animationDelay]);

  return (
    <div className="site-contain tablesalestracker" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
      <div className="form">
        <div className="field-group ">
          <div className="field-wrap submit-wrap">
            <span className="confettiWrapper">
              <button
                type="button"
                onClick={handleClick}
                className="test btn btn-pill lg-btn o-o"
                ref={buyRef}
              >
                <Heart />
                {' '}
                GOT IT
              </button>
            </span>
            <div className="confettiWrapper">
              {buyClick && startAnimation && (
                <div id="confettiContainer">
                  <BuyBtnAnim buyRef={buyRef} onAnimationComplete={() => setBuyClick(false)} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SAConfirmationPage;
